import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import placeholderImg from '@/assets/Energy_Release_Component.png'
import { LAYER_ATTRIBUTIONS } from '@/constants/layers/attributions'
import type { LayerInfo } from '@/types/LayerInfo'

// Shared by the legend and the info popup
const legendItems = [
  {
    text: {
      'en-US': 'Less than 60%',
      'es-ES': 'Menos de 60%',
      'pt-BR': 'Menos de 60%',
      'fr-FR': 'Moins de 60%'
    },
    color: '#1a9641',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': '60% to 79%',
      'es-ES': '60% a 79%',
      'pt-BR': '60% a 79%',
      'fr-FR': '60% à 79%'
    },
    color: '#a6d96a',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': '80% to 89%',
      'es-ES': '80% a 89%',
      'pt-BR': '80% a 89%',
      'fr-FR': '80% à 89%'
    },
    color: '#ffffbf',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': '90% to 96%',
      'es-ES': '90% a 96%',
      'pt-BR': '90% a 96%',
      'fr-FR': '90% à 96%'
    },
    color: '#fdae61',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': '97% to 99%',
      'es-ES': '97% a 99%',
      'pt-BR': '97% a 99%',
      'fr-FR': '97% à 99%'
    },
    color: '#d7191c',
    icon: 'mdi-square'
  },
  {
    text: {
      'en-US': '100%+',
      'es-ES': '100%+',
      'pt-BR': '100%+',
      'fr-FR': '100%+'
    },
    color: '#a50026',
    icon: 'mdi-square'
  }
]

// Description pending review by Matt Jolly (D2208-482)
const info: LayerInfo = {
  description: {
    'en-US':
      "Daily Energy Release Component (ERC) percentile forecast for North Africa. ERC is a relative measure of hot and dry conditions; percentiles compare each day's forecast with the historical conditions at the same location.",
    'es-ES':
      'Pronóstico diario del percentil del Componente de Liberación de Energía (ERC) para el norte de África. El ERC es una medida relativa de las condiciones de calor y sequedad; los percentiles comparan el pronóstico de cada día con las condiciones históricas en el mismo lugar.',
    'pt-BR':
      'Previsão diária do percentil do Componente de Liberação de Energia (ERC) para o Norte da África. O ERC é uma medida relativa das condições de calor e secura; os percentis comparam a previsão de cada dia com as condições históricas no mesmo local.',
    'fr-FR':
      "Prévision quotidienne du percentile de la composante de dégagement d'énergie (ERC) pour l'Afrique du Nord. L'ERC est une mesure relative des conditions chaudes et sèches ; les percentiles comparent la prévision de chaque jour aux conditions historiques au même endroit."
  },
  categories: legendItems,
  credit: LAYER_ATTRIBUTIONS.usfsFireLab,
  sourceUrl: 'https://www.wfas.net/'
}

export const energyReleaseNorthAfrica: LayerRaw = {
  id: 'EnergyRelease',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  extraArcgisParameter: { copyright: info.credit },
  title: {
    'en-US': 'Energy Release Component (ERC)',
    'pt-BR': 'Componente de Liberação de Energia (ERC)',
    'es-ES': 'Componente de Liberación de Energía (ERC)',
    'fr-FR': "Composante de libération d'énergie (ERC)"
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  opacity: 0.5,
  customProperties: { group: 'riskLayers', img: placeholderImg, info },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'naf:ercperc',
      visible: true,
      legend: {
        title: {
          'en-US': 'Energy Release Component (ERC)',
          'pt-BR': 'Componente de Liberação de Energia (ERC)',
          'es-ES': 'Componente de Liberación de Energía (ERC)',
          'fr-FR': "Composante de libération d'énergie (ERC)"
        },
        items: legendItems
      }
    }
  ],
  icon: 'mdi-barley'
}
